var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6365_3809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.333 2.66699V6.66699H11.333",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6602 9.99968C13.2269 11.2263 12.4066 12.2788 11.323 12.9987C10.2394 13.7185 8.95122 14.0667 7.65253 13.9907C6.35383 13.9148 5.11501 13.4188 4.12275 12.5775C3.13048 11.7362 2.43853 10.5952 2.15116 9.32639C1.86378 8.05761 1.99656 6.72981 2.52949 5.54306C3.06241 4.35632 3.9666 3.37493 5.10581 2.74678C6.24502 2.11863 7.55753 1.87775 8.84555 2.06045C10.1336 2.24314 11.3273 2.83951 12.2469 3.75968L15.3336 6.66635",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6365_3809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCw);
export default __webpack_public_path__ + "static/media/rotate-cw.fac7290157e56e4509d56fa0505bc184.svg";
export { ForwardRef as ReactComponent };